import { render, staticRenderFns } from "./PalletInfo.vue?vue&type=template&id=66c135b7"
import script from "./PalletInfo.vue?vue&type=script&lang=js"
export * from "./PalletInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports